<div class="profile-sidebar">
	<div class="widget-profile pro-widget-content">
		<div class="profile-info-widget">
			<a href="javascript:void(0)" class="booking-doc-img border-r-12">
				<img class="border-less" [src]="app.getUserImage(patient?.picture)" alt="User Image">
			</a>
			<div class="profile-det-info">
				<h3 class="blue-text">{{patient?.name}}</h3>
				<div class="patient-details">
					<h5><i class="fa fa-birthday-cake"></i> {{patient?.birthDate | date :'MMM d, y'}}, {{patient?.age}}
						years</h5>
					<!-- <h5 class="mb-0"><i class="fa fa-map-marker-alt"></i> Newyork, USA</h5> -->
				</div>
			</div>
		</div>
	</div>
	<div class="dashboard-widget">
		<nav class="dashboard-menu">
			<ul>
				<li routerLinkActive="active">
					<a [routerLink]="'/' + app?.languageCode +'/patients/visit'">
						<i class="fa fa-bookmark"></i>
						<span>{{ 'Patient.Visit' | translate }}</span>
					</a>
				</li>

				<li routerLinkActive="active">
					<a [routerLink]="'/' + app?.languageCode +'/patients/relative'">
						<i class="fa fa-users"></i>
						<span>{{ 'Patient.Relatives' | translate }}</span>
					</a>
				</li>

				<li routerLinkActive="active">
					<a [routerLink]="'/' + app?.languageCode +'/patients/medical-history'">
						<i class="fa fa-heartbeat"></i>
						<span>{{ 'NavBar.medicalhistory' | translate }}</span>
					</a>
				</li>

				<li routerLinkActive="active">
                    <a [routerLink]="'/' + app?.languageCode +'/Tebgram/activity'">
                        <i class="fa fa-user"></i>
                        <span>{{ 'social.myCommAct' | translate }}</span>
                    </a>
                </li>
				
				<li routerLinkActive="active">
                    <a [routerLink]="'/' + app?.languageCode +'/Tebgram/profile'">
                        <i class="fa fa-bookmark"></i>
                        <span>{{ 'social.myCommProfile' | translate }}</span>
                    </a>
                </li>

				<li routerLinkActive="active">
					<a [routerLink]="'/' + app?.languageCode +'/patients/settings'">
						<i class="fa fa-cog"></i>
						<span>{{ 'Patient.ProfileSettings' | translate }}</span>
					</a>
				</li>
				<li routerLinkActive="active">
					<a [routerLink]="'/' + app?.languageCode +'/patients/patients-change-password'">
						<i class="fa fa-lock"></i>
						<span>{{ 'Patient.ChangePassword' | translate }}</span>
					</a>
				</li>
				<li routerLinkActive="active" class="hoverSideMenu">
					<a (click)="app?.mainLogOut()" style="cursor: pointer;">
						<i class="fa fa-sign-out "></i>
						<span>{{ 'Patient.Logout' | translate }}</span>
					</a>
				</li>
			</ul>
		</nav>
	</div>
</div>